import instance from "../xhrService";
import db from '../../db/db';
import { withOfflineFallback } from '../offlineFallback';

export const inspectionQuestionApi = {
  show: (id: number) =>
    // db.questions is keyed on inspection_id, which the download sets before
    // storing. navigator.onLine reports true after an offline reload, so the
    // cache must also be read when the request fails.
    withOfflineFallback(
      () =>
        instance
          .get(`/api/inspections/${id}/questions`)
          .then((response) => response.data),
      () => db.questions.get(Number(id)),
    ),
  getDefaultAnswers: async (id: number) => {
    return instance
      .get(`/api/inspectionsQuestion/getDefaultQuestions/${id}`)
      .then((response) => response.data);
  },
};
